export enum CRM_TRIGGER_TYPE {
	SCENARIO = 'scenario',
	WORKFLOW = 'workflow',
}

export enum WORKFLOW_TYPE {
	TEXTING = 'texting',
	CALL_TRANSFER = 'call_transfer',
}
